import React from 'react';
import { Button, ButtonToolbar, Card, CardBody, Col } from 'reactstrap';
import SponsorshipTable from './SponsorshipTable';
import { useSponsorshipUIContext } from '../SponsorshipUIProvider';

const SponsorshipTableWrapper = () => {
  const sponsorshipUIContext = useSponsorshipUIContext();

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody className="products-list">
          <div className="card__title">
            <h5 className="bold-text">Data Sponsorship List</h5>
            <ButtonToolbar className="products-list__btn-toolbar-top">
              <Button color="primary" onClick={sponsorshipUIContext.openNewSponsorshipDialog}>
                Add new
              </Button>
            </ButtonToolbar>
          </div>
          <SponsorshipTable />
        </CardBody>
      </Card>
    </Col>
  );
};

export default SponsorshipTableWrapper;
